// Generated by scripts/generate-translations.mjs. Do not edit.
import locale0 from "./en.json";
import locale1 from "./ru.json";
import locale2 from "./uk.json";
import locale3 from "./es.json";
import locale4 from "./pt-BR.json";
import locale5 from "./tr.json";
import locale6 from "./ar.json";
import locale7 from "./id.json";
import locale8 from "./de.json";
import locale9 from "./fr.json";
import locale10 from "./pl.json";
import locale11 from "./fa.json";
import locale12 from "./uz.json";
import locale13 from "./vi.json";
import locale14 from "./hi.json";
import locale15 from "./it.json";
import locale16 from "./ja.json";
import locale17 from "./ko.json";
import locale18 from "./zh-Hans.json";
import locale19 from "./zh-Hant.json";

export const generatedTranslationResources = {
    "en": { translation: locale0 },
    "ru": { translation: locale1 },
    "uk": { translation: locale2 },
    "es": { translation: locale3 },
    "pt-BR": { translation: locale4 },
    "tr": { translation: locale5 },
    "ar": { translation: locale6 },
    "id": { translation: locale7 },
    "de": { translation: locale8 },
    "fr": { translation: locale9 },
    "pl": { translation: locale10 },
    "fa": { translation: locale11 },
    "uz": { translation: locale12 },
    "vi": { translation: locale13 },
    "hi": { translation: locale14 },
    "it": { translation: locale15 },
    "ja": { translation: locale16 },
    "ko": { translation: locale17 },
    "zh-Hans": { translation: locale18 },
    "zh-Hant": { translation: locale19 },
};
